const currency = {}

currency.install = function (Vue) {
  /*
  * Customiza formato de moneda
  */
  Vue.filter('currency', function (amount, symbol, decimals) {
    let parsedAmount = `${symbol}` + parseFloat(amount).toFixed(decimals).replace('.', ',');
    return parsedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  });
}

export default currency


// WEBPACK FOOTER //
// ./src/utils/filters/currency.js